module.exports = __webpack_public_path__ + "img/circles2.500beea9.svg";